/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type OrganisationRole = "ADMIN" | "LIMITED" | "MEMBER" | "%future added value";
export type UserRoleV2 = "ADMIN" | "CLIENT" | "CONSULTANT" | "SUPERADMIN" | "%future added value";
export type VerificationLevel = "FUTURED" | "UNVETTED" | "VETTED" | "%future added value";
export type UserContextHandlerQueryVariables = {};
export type UserContextHandlerQueryResponse = {
    readonly v2: {
        readonly viewer: {
            readonly user: {
                readonly id: string;
                readonly role: UserRoleV2 | null;
                readonly organisationRole: OrganisationRole | null;
                readonly verificationLevel: VerificationLevel | null;
                readonly email: string | null;
                readonly locked: boolean | null;
                readonly consultant: {
                    readonly lifecycle: {
                        readonly accepted: boolean | null;
                        readonly emailVerified: boolean | null;
                        readonly basicProfileCompleted: boolean | null;
                        readonly marketplaceMember: boolean | null;
                        readonly privateCloudTalent: boolean | null;
                    } | null;
                } | null;
                readonly client: {
                    readonly memberOf: ReadonlyArray<{
                        readonly name: string;
                        readonly hasExplore: boolean | null;
                        readonly ssoConfig: {
                            readonly requireSso: boolean | null;
                        } | null;
                    }>;
                } | null;
            } | null;
        } | null;
    } | null;
};
export type UserContextHandlerQuery = {
    readonly response: UserContextHandlerQueryResponse;
    readonly variables: UserContextHandlerQueryVariables;
};



/*
query UserContextHandlerQuery {
  v2 {
    viewer {
      user {
        id
        role
        organisationRole
        verificationLevel
        email
        locked
        consultant {
          lifecycle {
            accepted
            emailVerified
            basicProfileCompleted
            marketplaceMember
            privateCloudTalent
            id
          }
          id
        }
        client {
          memberOf {
            name
            hasExplore
            ssoConfig {
              requireSso
              id
            }
            id
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "role",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "organisationRole",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "verificationLevel",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "email",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "locked",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "accepted",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "emailVerified",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "basicProfileCompleted",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "marketplaceMember",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "privateCloudTalent",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "hasExplore",
        "args": null,
        "storageKey": null
    } as any), v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "requireSso",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "UserContextHandlerQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "v2",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "V2",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "viewer",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ViewerV2",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "user",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UserV2",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        (v1 /*: any*/),
                                        (v2 /*: any*/),
                                        (v3 /*: any*/),
                                        (v4 /*: any*/),
                                        (v5 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "consultant",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ConsultantV2",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "lifecycle",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Lifecycle",
                                                    "plural": false,
                                                    "selections": [
                                                        (v6 /*: any*/),
                                                        (v7 /*: any*/),
                                                        (v8 /*: any*/),
                                                        (v9 /*: any*/),
                                                        (v10 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "client",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ClientV2",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "memberOf",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Organisation",
                                                    "plural": true,
                                                    "selections": [
                                                        (v11 /*: any*/),
                                                        (v12 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "ssoConfig",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "SsoConfig",
                                                            "plural": false,
                                                            "selections": [
                                                                (v13 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "UserContextHandlerQuery",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "v2",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "V2",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "viewer",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ViewerV2",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "user",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UserV2",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        (v1 /*: any*/),
                                        (v2 /*: any*/),
                                        (v3 /*: any*/),
                                        (v4 /*: any*/),
                                        (v5 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "consultant",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ConsultantV2",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "lifecycle",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Lifecycle",
                                                    "plural": false,
                                                    "selections": [
                                                        (v6 /*: any*/),
                                                        (v7 /*: any*/),
                                                        (v8 /*: any*/),
                                                        (v9 /*: any*/),
                                                        (v10 /*: any*/),
                                                        (v0 /*: any*/)
                                                    ]
                                                },
                                                (v0 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "client",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ClientV2",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "memberOf",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Organisation",
                                                    "plural": true,
                                                    "selections": [
                                                        (v11 /*: any*/),
                                                        (v12 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "ssoConfig",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "SsoConfig",
                                                            "plural": false,
                                                            "selections": [
                                                                (v13 /*: any*/),
                                                                (v0 /*: any*/)
                                                            ]
                                                        },
                                                        (v0 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "UserContextHandlerQuery",
            "id": null,
            "text": "query UserContextHandlerQuery {\n  v2 {\n    viewer {\n      user {\n        id\n        role\n        organisationRole\n        verificationLevel\n        email\n        locked\n        consultant {\n          lifecycle {\n            accepted\n            emailVerified\n            basicProfileCompleted\n            marketplaceMember\n            privateCloudTalent\n            id\n          }\n          id\n        }\n        client {\n          memberOf {\n            name\n            hasExplore\n            ssoConfig {\n              requireSso\n              id\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '507dfad216ec72176d487102077d57bf';
export default node;
